module.exports = __webpack_public_path__ + "media/images/admin/checkbox-active-0ceb71df176cbd364ae2a8af72c03c6e.svg";